import { Route, Routes } from "react-router-dom";

import PriceRemarkJustifications from "./list";

export default function PriceRemarkJustificationsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PriceRemarkJustifications />} />
    </Routes>
  );
}
